import { AppUser } from "./types.global";

export const checkForPermission = (user: AppUser, permission: string) => {
  throw new Error("NOT IMPLEMENTED");
};

export const checkIfAdmin = (user: AppUser | null) => {
  if(!user) return false;
  return user.roles.findIndex(x => x === "Admin") !== -1;
};

// export const passwordRegex = /^(?=.*\d)(?=(.*\W){2})(?=.*[a-zA-Z])(?!.*\s).{1,35}$/;
export const passwordRegex = /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/;